'use client';

import { use } from 'react';

import { ProductCompareContext } from '../context/product-compare-context';

export const useProductCompare = () => {
   const context = use(ProductCompareContext);

   return {
      productItems: context.productItems,
      isInitialized: context.isInitialized,
      addProduct: context.addProduct,
      removeProduct: context.removeProduct,
      removeAllProducts: context.removeAllProducts
   };
};
